import { workItemIcons } from "app/components/workItemIcons";
import React from "react";

export default function TicketTypeIcon({
  iconName,
  size = 24,
}: {
  iconName: string;

  size?: number;
}) {
  const Icon = workItemIcons[iconName];

  if (!Icon) return null;
  return <Icon width={size} height={size} />;
}
